import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from './app';
import GambitManager from './GambitManager';
export default class SearchManager {
  /**
   * Whether experimental CJK search mode is enabled.
   */
  static isCjkMode() {
    var _ref;
    const settings = app.data.settings;
    return (_ref = settings == null ? void 0 : settings['search_cjk_mode']) != null ? _ref : false;
  }

  /**
   * The minimum query length for the current forum. Experimental CJK search mode
   * drops it to 1, since a single character is often a whole word in languages
   * without word spaces; the substring match backing that mode has no minimum.
   */
  static minSearchLength() {
    return this.isCjkMode() ? 1 : this.MIN_SEARCH_LEN;
  }

  /**
   * Time to wait (in milliseconds) after the user stops typing before triggering a search.
   */

  constructor(state) {
    /**
     * An object which stores previously searched queries and provides convenient
     * tools for retrieving and managing search values.
     */
    _defineProperty(this, "state", void 0);
    /**
     * The gambit manager that will convert search query gambits
     * into API filters.
     */
    _defineProperty(this, "gambits", new GambitManager());
    this.state = state;
  }
}
/**
 * The minimum query length before sources are searched.
 */
_defineProperty(SearchManager, "MIN_SEARCH_LEN", 3);
_defineProperty(SearchManager, "SEARCH_DEBOUNCE_TIME_MS", 250);
flarum.reg.add('core', 'common/SearchManager', SearchManager);